import { useFormikContext } from "formik"
import { Grid, Stack, Typography } from "@mui/material"

import { FormikChip } from "../../../../../shared/components/forms/Formik"
import { LocalizedEnum, LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { WeekDays } from "../../productGroup/productGroupTypes"

import type { CreateUpdateProductFormValues } from "../productsTypes"

type WeekDaysFieldProps = Readonly<{
    groupWeekDays: ReadonlyArray<WeekDays>
}>

export function WeekDaysField({ groupWeekDays }: WeekDaysFieldProps) {
    const { values } = useFormikContext<CreateUpdateProductFormValues>()
    const isLimitedByGroup = groupWeekDays.length > 0

    // a selected day outside the group stays enabled so it can be unselected
    const isDayDisabled = (day: WeekDays) =>
        isLimitedByGroup && !groupWeekDays.includes(day) && !values.availabilityDetails.weekDays.includes(day)

    return (
        <Stack spacing=".5rem">
            <LocalizedStrict id="product-create-availability-week-days-label">
                <Typography variant="subtitle1">Available on:</Typography>
            </LocalizedStrict>
            <Grid container gap={1}>
                {Object.values(WeekDays).map((day) => (
                    <Grid key={day} item>
                        <LocalizedEnum base="product-group-form-week-day" enumValue={day}>
                            <FormikChip
                                id={day}
                                name="availabilityDetails.weekDays"
                                value={day}
                                disabled={isDayDisabled(day)}
                            >
                                {day.toLowerCase()}
                            </FormikChip>
                        </LocalizedEnum>
                    </Grid>
                ))}
            </Grid>
            {isLimitedByGroup ? (
                <LocalizedStrict id="product-create-availability-week-days-group-helper-text">
                    <Typography variant="body2" color="text.secondary">
                        Only the product group's days can be selected. Leave all days unselected to sell the product on
                        all of them.
                    </Typography>
                </LocalizedStrict>
            ) : (
                <LocalizedStrict id="product-create-availability-week-days-helper-text">
                    <Typography variant="body2" color="text.secondary">
                        Leave all days unselected to sell the product every day.
                    </Typography>
                </LocalizedStrict>
            )}
        </Stack>
    )
}
